module.exports = __webpack_public_path__ + "img/asphalt_shingles.f49dc630.jpg";